import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/config/router.js'

// const timeStamp = Math.floor(Date.now() / 1000)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {    
    token: null,
    user:{},
    apiCalls: {},
    language_id: '1',   
    locationMode: false, 
    drawingImage: "",
    drawingMode: false, 
    locationSearchMode: false,
    x_position_search: 0,
    y_position_search: 0,
    x_position: 0,
    y_position: 0,
    view_comment :false,
    locationViewMode: false, 
    drawViewMode: false, 
    x_position_view: 0,
    y_position_view: 0,
    openCommentSection: true,
    drag: false
  },
  mutations: {
    toggleCommentSection(state) {
      state.openCommentSection = !state.openCommentSection;
    },
    SET_USER_DATA(state, userData){
      state.user = userData
    }
  },
  actions: {
    setUserData({ commit }, userData){      
      commit("SET_USER_DATA", userData);         
      router.push({name: 'Dashboard'})           
    }
  }
})
